import httpClient from '../httpClient';

const get = async (id) => {
  return await httpClient.get(
    `${process.env.REACT_APP_API_HOST}/mass_modification_date/${id}`,
  );
};

const patch = async (id, data) => {
  return await httpClient.patch(
    `${process.env.REACT_APP_API_HOST}/mass_modification_date/${id}/modify_contract_date/`,
    data,
  );
};

const getCurrentDates = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/mass_modification_date/${query}/current_dates/${
        search ? `?filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/mass_modification_date/${query}/current_dates/?page[number]=${page}&page[size]=${pageSize}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const getContractors = async (
  query = {},
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/mass_modification_date/${
        query.id
      }/contractors_export/?filter[fecha_inicio]=${query.fecha_inicio}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/mass_modification_date/${query.id}/contractors/?filter[fecha_inicio]=${
        query.fecha_inicio
      }&page[number]=${page}&page[size]=${pageSize}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

export { get, patch, getCurrentDates, getContractors };
